"use client";

import { CircularProgress } from "@mui/material";
import React from "react";

import PageContainer from "@/components/atoms/PageContainer";
import AlertBlock from "@/components/molecules/AlertBlock";
import Suspense from "@/components/molecules/Suspense";
import PageLayout from "@/components/templates/PageLayout";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import useGetSalesProduct from "@/hooks/requests/sales-product/use-get-sales-product";
import { PlanMessages } from "@/messages/plans/plan.messages";

import Header from "./components/Header";
import PricingCards from "./components/PricingCards";
import { getInitialSalesProductFilterValues, pageNumber, pageSize } from "./constants";

type Props = {
  messages: PlanMessages;
};

function PlansPage({ messages }: Props) {
  const { lang } = useLanguage();
  const filters = getInitialSalesProductFilterValues();

  const { data, isLoading, error } = useGetSalesProduct({ pageNumber, pageSize, filters });

  const BREAD_CRUMBS = [{ title: messages.breadCrumbTitle, href: ROUTE_URLS.plans(lang) }];

  const shouldLoadCards = !!data;
  const shouldLoadError = !isLoading && !!error;

  return (
    <PageLayout breadCrumbs={BREAD_CRUMBS} messages={messages}>
      <PageContainer>
        <Suspense isSuspended={isLoading} fallback={<CircularProgress />}>
          {shouldLoadCards &&
            data.items.map((salesProduct, index) => (
              <Header salesProduct={salesProduct} key={`${index}-${salesProduct.id}`}>
                <PricingCards messages={messages} salesProduct={salesProduct} />
              </Header>
            ))}

          {!!shouldLoadError && (
            <AlertBlock
              title={messages.salesProductErrorToLoad}
              description={error.message}
              alt={messages.salesProductNotFoundAlt}
            />
          )}
        </Suspense>
      </PageContainer>
    </PageLayout>
  );
}

export default PlansPage;
